<template>
  <label
    class="status-switch"
    :class="{ on: modelValue, disabled }"
    :title="title"
  >
    <input
      type="checkbox"
      class="status-switch-input"
      :checked="modelValue"
      :disabled="disabled"
      @change="onChange"
    />
    <span class="status-switch-track" aria-hidden="true" />
  </label>
</template>

<script>
export default {
  name: 'StatusSwitch',
  props: {
    modelValue: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    title: { type: String, default: '' },
  },
  emits: ['update:modelValue', 'change'],
  methods: {
    onChange(e) {
      const v = !!(e && e.target && e.target.checked)
      this.$emit('update:modelValue', v)
      this.$emit('change', v)
    },
  },
}
</script>

<style scoped>
.status-switch {
  position: relative;
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  cursor: pointer;
}
.status-switch.disabled {
  cursor: not-allowed;
  opacity: 0.72;
}
.status-switch-input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  pointer-events: none;
}
.status-switch-track {
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;
  border-radius: 999px;
  background: #d0d5dd;
  transition: background 0.18s ease;
}
.status-switch-track::after {
  content: '';
  position: absolute;
  top: 3px;
  left: 3px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 3px rgba(16, 24, 40, 0.18);
  transition: transform 0.18s ease;
}
.status-switch.on .status-switch-track {
  background: #2f6af6;
}
.status-switch.on .status-switch-track::after {
  transform: translateX(20px);
}
</style>
